import React from 'react'
import type { StyleClasses } from '../../styles'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core'
import type { InputLabelProps as MuiInputLabelProps } from '@material-ui/core/InputLabel'
import MuiInputLabel from '@material-ui/core/InputLabel'

const useStyles = makeStyles<Theme, InputLabelProps>(
  (theme) => ({
    formControl: {
      position: 'relative'
    },
    label: {
      display: 'block',
      color: theme.paintscout.palette.brand.Neutral.P40,
      fontWeight: 500,
      whiteSpace: 'nowrap',
      fontSize: '1rem',
      '& span': {
        color: theme.palette.error.main,
        position: 'absolute',
        top: 2.5
      }
    },
    labelFocused: {
      color: theme.palette.primary.main
    },
    sublabel: {
      fontSize: '1.2rem',
      color: theme.paintscout.palette.brand.Neutral.P70,
      fontWeight: theme.typography.fontWeightRegular,
      '&.Mui-focused': {
        color: theme.paintscout.palette.brand.Neutral.P70
      }
    },
    sublabelFocused: {},
    focused: {},
    disabled: {},
    required: {},
    error: {}
  }),
  { name: 'PaintScoutInputLabel' }
)

export interface InputLabelProps extends Omit<MuiInputLabelProps, 'variant'> {
  classes?: MuiInputLabelProps['classes'] & StyleClasses<typeof useStyles>
  variant?: 'label' | 'sublabel'
}

function InputLabel(props: InputLabelProps) {
  const classes = useStyles(props)
  const { variant, ...baseInputLabelProps } = props
  const { label, sublabel, sublabelFocused, labelFocused: _labelFocused, ...baseClasses } = classes

  return (
    <MuiInputLabel
      classes={{
        root: variant === 'sublabel' ? sublabel : label,
        focused: variant === 'sublabel' ? sublabelFocused : sublabelFocused,
        ...baseClasses
      }}
      {...baseInputLabelProps}
      shrink={true}
    />
  )
}

export default InputLabel
